export default __webpack_public_path__ + "static/media/comedora-producto-tomaco.ffdcc56b.png";